import { useState } from 'react'
import cn from 'clsx'
import { getOS } from '@/utils'

export const ContentInput = ({
    id,
    type = 'text',
    value,
    
    // @todo to add for the future. e.g of usage: Acreage field would have "acres" as a suffix
    // prefix,
    // suffix,
    alignment,
    grow,
    placeholder,
    onBlur,
    onChange,
    allowsNewLine = false,
    shouldBlurOnEnter = true,
}) => {
    
    const [originalValue, setOriginalValue] = useState(value)
    
    const onKeyDown = event => {
        if (event.key === 'Enter') {
            if ((getOS() === 'MacOS' ? event.metaKey : event.ctrlKey) && type === 'textarea' && allowsNewLine) {
                event.preventDefault()
                insertNewLineAtCursor()
            } else {
                event.preventDefault()
                if (shouldBlurOnEnter) event.target.blur()
            }
        } else if (event.key === 'Escape') {
            onChange(originalValue)
            event.target.dataset.ignoreContentUpdate = true
            event.target.blur()
        }
    }
    
    const insertNewLineAtCursor = () => {
        const selection = window.getSelection()
        
        if (!selection.rangeCount) return
        const range = selection.getRangeAt(0)
        
        const insertBreak = r => {
            // eslint-disable-next-line no-restricted-globals
            const br = document.createElement('br')
            
            r.insertNode(br)
            moveCursorAfter(br)
            return br
        }
        
        const moveCursorAfter = node => {
            // eslint-disable-next-line no-restricted-globals
            const newRange = document.createRange()
            
            newRange.setStartAfter(node)
            newRange.setEndAfter(node)
            selection.removeAllRanges()
            selection.addRange(newRange)
        }
        
        if (range.endOffset === range.startContainer.length) {
            insertBreak(range)
            insertBreak(range)
        } else {
            range.deleteContents()
            insertBreak(range)
        }
    }
    
    const handleFocus = () => {
        setOriginalValue(value)
    }
    
    const handleBlur = event => {
        if (!JSON.parse(event.target.dataset.ignoreContentUpdate || 'false')) {
            setOriginalValue(value)
            onBlur(event.target.value)
        } else {
            event.target.dataset.ignoreContentUpdate = false
        }
    }
    
    const handleBlurTextarea = event => {
        if (!JSON.parse(event.target.dataset.ignoreContentUpdate || 'false')) {
            onChange(event.target.innerText)
            setOriginalValue(event.target.innerText)
            onBlur(event.target.innerText, event.target)
        } else {
            event.target.innerText = originalValue
            event.target.dataset.ignoreContentUpdate = false
        }
    }
    
    return (
        <div className="flex items-center flex-fill w-full">
            {type === 'text' &&
                <input
                    id={id}
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    className="content-editable__input whitespace-pre-line"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={ev => onChange(ev.target.value)}
                    onKeyDown={onKeyDown} />
            }
            {type === 'textarea' && 
                <div id={id}
                    role="textbox"
                    contentEditable={true}
                    suppressContentEditableWarning={true}
                    placeholder={placeholder}
                    className={cn('content-editable__textarea whitespace-pre-line',
                        { 'grow-on-focus': grow, 'justify-end': alignment === 'right' }, `grow-${grow}`)}
                    onFocus={handleFocus}
                    onBlur={handleBlurTextarea}
                    onKeyDown={onKeyDown}>
                    {value}
                </div>
            }
        </div>
    )
}
